import { Injectable } from '@angular/core';
import { Observable, Subject } from  "rxjs";
@Injectable({
  providedIn: 'root'
})
export class OutwardService {
  private _refreshPage = new Subject<void>();
  private _resetFilters = new Subject<void>();
  private _resetHeaders = new Subject<void>();
  private _deleteUser = new Subject<void>();
  private _refreshwithFilters = new Subject<void>();
  constructor() { }


  get refreshPage()
  {
     return this._refreshPage;
  }

  get resetFilters()
  {
     return this._resetFilters;
  }

  get resetHeaders()
  {
     return this._resetHeaders;
  }
  get deleteReg()
  {
     return this._deleteUser;
  }
  
  get refreshwithFilters()
  {
     return this._refreshwithFilters;
  }
 
}
